<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">   
      <div class="pledge-box1-top">
        <label class="el-radio"> 
          <span class="el-radio-input is-checked" :class="{'is-checked': reporting}" @click="reporting=true, curDateType = finance[0][0]"> 
            <span class="el-radio-inner"></span> 
            <input class="el-radio-original" value="按报告期" type="radio">
          </span> 
          <span class="el-radio-label">按报告期</span> 
        </label>
        <label class="el-radio"> 
          <span class="el-radio-input" :class="{'is-checked': !reporting}" @click="reporting=false, curDateType = yearList[0][0]"> 
            <span class="el-radio-inner"></span> 
            <input class="el-radio-original" value="按年度" type="radio">
          </span> 
          <span class="el-radio-label">按年度</span> 
        </label>

        <div class="Quarterly-Report">
          <div class="head-title" @click.stop="showDateDropmemu($event)">
            {{ curDateType }}
            <span class="close-bot" @click.stop="showDateDropmemu($event)"></span>
          </div>
          <ul class="menu-lanmu" v-show="dateDropmenu && reporting">
            <li v-for="h in finance">
              <a href="javascript:;" v-if="curDateType != h[0]" @click="clickDropmenu(), curDateType = h[0]">{{ h[0] }}</a>
            </li>   
          </ul>
           <ul class="menu-lanmu" v-show="dateDropmenu && !reporting">  
            <li v-for="h in yearList">
              <a href="javascript:;" v-if="curDateType != h[0]" @click="clickDropmenu(), curDateType = h[0]">{{ h[0] }}</a>
            </li>   
          </ul>
        </div>
      </div>
      <div class="Single-list-main" v-if="reporting">  
        <ul class="Single-list-box">
          <li v-for="(key, val) in fzb" track-by="$index">
            <p class="date">{{ key }}</p> 
            <template  v-for="v in finance">
              <p class="time" v-if="v[0] == curDateType"> {{ v[1][val] ? v[1][val] : '--' | money }} </p>
            </template>
          </li> 
        </ul>   
      </div>

      <div class="Single-list-main" v-if="!reporting">  
        <ul class="Single-list-box">
          <li v-for="(key, val) in fzb" track-by="$index">
            <p class="date">{{ key }}</p> 
            <template  v-for="v in yearList">
              <p class="time" v-if="v[0] == curDateType"> {{ v[1][val] ? v[1][val] : '--' | money }} </p>
            </template>
          </li>  
        </ul>   
      </div>

      <!-- <div class="Single-list-main" v-if="fzb.length == 0"> 
        <div class="Block-trade-no">暂无数据</div>
      </div> -->
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import echartMix from '../../common/echartMix'
  import echarts from 'echarts'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'FinanceView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, echartMix, wxshareMix],
    data () {
      return {
        reporting: true,    //按报告期
        curDateType: '',
        yearList: [],
        finance: [],
        fzb: {
          '货币资金(元)': 'capital', 
          '应收票据(元)': 'billreceivable', 
          '应收账款(元)': 'receivables', 
          '预付款项(元)': 'prepayment', 
          '其他应收款(元)': 'otherreceivables', 
          '存货(元)': 'inventory', 
          '其他流动资产(元)': 'otherliquidasset', 
          '流动资产合计(元)': 'liquidasset', 
          '固定资产(元)': 'fixedassets', 
          '在建工程(元)': 'constructioninprocess', 
          '无形资产(元)': 'intangibleassets', 
          '递延所得税资产(元)': 'deferredtaxasset', 
          '其他非流动资产(元)': 'otherilliquidasset', 
          '非流动资产合计(元)': 'illiquidasset', 
          '资产总计(元)': 'assettotal', 
          '短期借款(元)': 'shorttermborrowing', 
          '应付账款(元)': 'accountspayable', 
          '预收款项(元)': 'depositreceived', 
          '应付职工薪酬(元)': 'payrollpayable', 
          '应交税费(元)': 'taxesandduespayable',
          '其他应付款(元)': 'otherpayables', 
          '流动负债合计(元)': 'currentliability', 
          '长期借款(元)': 'longtermborrowing', 
          '非流动负债合计(元)': 'noncurrentliabilities', 
          '负债合计(元)': 'liabilities', 
          '实收资本(或股本)(元)': 'paidincapital', 
          '资本公积(元)': 'capitalreserves', 
          '盈余公积(元)': 'surplusreserves', 
          '未分配利润(元)': 'undistributedprofits', 
          '归属于母公司股东权益合计(元)': 'totalownersequityparent', 
          '少数股东权益(元)': 'minorityinterests', 
          '股东权益合计(元)': 'ownersequity', 
          '负债和股东权益合计(元)': 'liabilitiesownersequity'
        },
         gbfzb:{
            '其他储备(元)':'otherspecialreserves',
            '可收回本期税项(元)':'taxrecoverable',
            '可供出售金融资产(非流动)(元)':'financialasset_illiquid',
            '流动资产其他项目(元)':'liquidasset',
            '衍生金融负债(非流动)(元)':'derivativefinancialliabilities_illiquid',
            '留存收益(元)':'retainedincome',
            '总资产减流动负债(元)':'assetsminuscurrentliability',
            '流动负债其他项目(元)':'currentliability',
            '以公允价值计量且其变动计入当期损益的金融负债(非流动)(元)':'financialliabilities_illiquid',
            '负债及股东权益合计(元)':'liabilitiesownersequity',
            '商誉及无形资产(元)':'goodwillintangibleassets',
            '受限制存款及现金(元)':'restricteddeposits',
            '以公允价值计量且其变动计入当期损益的金融资产(流动)(元)':'financialasset',
            '持有至到期投资(非流动)(元)':'heldtomaturityinvestment_illiquid',
            '非流动负债其他项目(元)':'noncurrentliabilities',
            '递延收入(非流动)(元)':'deferredincome_illiquid',
            '归属于母公司股东权益(元)':'totalownersequityparent',
            '其他应付款项及应计费用(元)':'otherpayables',
            '净利率（%）':'jlv',
            '融资租赁负债(非流动)(元)':'financeleaseliabilities_illiquid',
            '长期借款(元)':'longtermborrowing',
            '流动资产周转率(次)':'ldzczzl',
            '拟派股息(元)':'proposeddividend',
            '融资租赁负债(流动)(元)':'financeleaseliabilities',
            '递延税项负债(元)':'deferredtaxliabilities',
            '归母净利润同比增长率(%)':'gmjlrtbzzl',
            '流动资产净值(元)':'liquidassetnet',
            '储备(元)':'specialreserves',
            '现金比率(%)':'xjbl',
            '总资产周转率(次)':'zzczzl',
            '每股经营活动产生的现金流量净额（元/股）':'mgjyxjllje',
            '土地使用权(元)':'landuse',
            '于联营和合营公司投资(元)':'investmentjointcompany',
            '每股公积金(元)':'mggjj',
            '非流动资产其他项目(元)':'illiquidasset',
            '总资产同比增长率(%)':'zzctbzzl',
            '持有至到期投资(流动)(元)':'heldtomaturityinvestment',
            '净资产收益率（%）':'jzcsyl',
            '净利润同比增长率(%)':'jlrtbzzl',
            '流动比率（倍）':'ldbl',
            '股东权益合计(元)':'ownersequity',
            '衍生金融资产(流动)(元)':'derivativefinancialassets',
            '可供出售金融资产(非流动)(元)':'sellablefinancialasset_illiquid',
            '应收关联公司款项(元)':'relatereceivables',
            '应付股息及利息(元)':'dividendpayable',
            '流动负债其他项目(元)':'othercurrentliability',
            '融资租赁负债(流动)(元)':'liabilities',
            '非流动负债其他项目(元)':'othernoncurrentliabilities',
            '营业收入同比增长率(%)':'yysrtbzzl',
            '比率计算状态':'bl_status',
            '衍生金融负债(流动)(元)':'derivativefinancialliabilities',
            '归属于母公司股东权益其他项目(元)':'otherownersequityparent',
            '递延税项资产(元)':'deferredtaxasset',
            '存货周转率（次）':'ckzzl',
            '扣非每股收益(元)':'kfmgsy',
            '预付款项、按金及其他应收款项(非流动)(元)':'prepayment_illiquid',
            '以公允价值计量且其变动计入当期损益的金融负债(流动)(元)':'financialliabilities',
            '速动比率（倍）':'sdbl',
            '资产总额(元)':'assettotal',
            '股东权益周转率(次)':'gdqyzzl',
            '递延收入(流动)(元)':'deferredincome',
            '可供出售金融资产(流动)(元)':'sellablefinancialasset',
            '毛利率（%）':'mlv',
            '股本(元)':'paidincapital',
            '非流动资产其他项目(元)':'otherilliquidasset',
            '经营现金流/营业收入':'jyxjlyysr',
            '应收账款及票据(元)':'receivables',
            '产权比率(%)':'cqbl',
            '于附属公司投资(元)':'investmentchildcompany',
            '物业、厂房及设备(元)':'equipment',
            '存货(元)':'inventory',
            '每股未分配利润(元)':'mgwfplr',
            '其中:股本溢价(元)':'stockpremium',
            '预付款项、按金及其他应收款项(流动)(元)':'prepayment',
            '衍生金融资产(非流动)(元)':'derivativefinancialassets_illiquid',
            '流动资产其他项目(元)':'otherliquidasset',
            '预收款/营业收入':'yskyysr',
            '商誉及无形资产(元)':'intangibleassets',
            '扣非净利润同比增长率(%)':'kfjlrtbzzl',
            '非控股权益(元)':'noncontrolinterests',
            '应收账款周转率（次）':'yszkzzl'}
        ,
        dataMap: {'年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31'},
      }
    },
    route: {
      data({to}) {
        if(to.query.stype == 6){
          this.fzb = this.gbfzb
        }
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;
          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.getFinance();
        }
      }
    },
    methods: {
      getFinance: function() {
        this.loading = true;

        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        $.ajax({
          url: apiUrl('/V1.0.0/company/finance'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            
            if (Object.keys(response.data).length) {
              
              let arr = []
              for (let k in response.data) {
                if (k.indexOf('年') >= 0) {
                  let n  = k.substr(0, 4) + this.dataMap[k.substr(4)]
                  arr.push([n, response.data[k]])
                } else {
                  arr.push([k, response.data[k]])
                }
              }

              arr.sort(function (a, b) {
                return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))
              })
              if (arr.length > 6) {
                for (let i = 0; i<6;i++) {
                  this.finance.push(arr[i])
                }
              } else {
                this.finance = arr
              }
              for (let i of arr) {
                if (i[0].indexOf('-12-') >= 0) {
                  this.yearList.push(i)
                }
              }
              if (this.yearList.length > 5) {
                this.yearList = this.yearList.slice(0, 5)
              }

              // 初始按报告期
              this.reporting = true;
              this.curDateType = this.finance[0][0];
            }

          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** Fzb.vue?0544120a
 **/